<template>
  <generic-historical v-if="hasAnyWebHooksModule"
    :get-detalle="getDetalleAux"
    :get-pag="getPagAux"
    :get-excel="getExcelAux"
    :get-params="getParamsAux"
    :get-params-detalle="getParamsDetalleAux"
    :excel-name="ExcelName"
    :id-vista="idVista"
    :header-url="headerUrl"
    :breadcrumbs="breadcrumbs"
    :vuexnamespace="vuexnamespace" />
  <detail-layout-full-width v-else class="h-full">
    <template slot="header">
      <base-header icon="user" :content="header" />
    </template>
    <template slot="main">
      <div class="dark:text-white">{{ $t('feedback.error.absent_module_error') }}</div>
    </template>
    <template slot="layout-extend">
      <base-footer>
        <template slot="actions">
        </template>
      </base-footer>
    </template>
  </detail-layout-full-width>
</template>

<script>
import _ from 'lodash'
import { i18n } from '@/i18n'
import GenericHistorical from '@/views/historical/GenericHistorical.vue'
import DetailLayoutFullWidth from '@/components/layout/DetailLayoutFullWidth.vue'
import { getWebhooksDetails } from '@/services/configurations/webhooks/getWebhooksDetails'
import { getHistoricalByWebHook } from '@/services/historical/getHistoricalByWebHook'
import { getHistoricalByWebHookExcel } from '@/services/historical/getHistoricalByWebHookExcel'

export default {
  name: 'list-webhook-historical',
  components: {
    GenericHistorical,
    DetailLayoutFullWidth,
  },
  data: function () {
    return {
      idVista: 91,
      vuexnamespace: 'historicalWebhook',
      headerUrl: this.$route.params.id ? 'configurations/clients/webhooks/detail' : 'configurations/webhooks/detail',
      breadcrumbs: [],
      ExcelName: `${_.kebabCase(i18n.t('webhooks.entity_name') + i18n.t('historical.entity_name'))}.xlsx`,
    }
  },
  mounted () {
    const breadcrumbs = [{ 
      url: this.role === 3 ? 'configurationssa' : 'configurations', 
      name: i18n.t('configurations.header') 
    }]
    if (this.$route.params.id) {
      breadcrumbs.push({ url: 'configurations/clients', name: i18n.t('clients.header') })
      breadcrumbs.push({
        url: 'configurations/clients/details',
        getter: 'app/headerBreadCrumb',
        setter: 'app/setheaderBreadCrumb',
        paths: ['Cliente']
      })
      breadcrumbs.push({
        url: 'configurations/clients/webhooks', 
        name: i18n.t('webhooks.header') 
      })
    } else {
      breadcrumbs.push({
        url: 'configurations/webhooks', 
        name: i18n.t('webhooks.header') 
      })
    }
    breadcrumbs.push({
      routeCallback: this.nameRouteCallback,
      dataCallback: this.nameDataCallback,
      getter: 'app/stateBreadCrumb',
      setter: 'app/setstateBreadCrumb',
    })
    this.breadcrumbs = breadcrumbs
  },
  computed: {
    role: function () {
      return this.$store.getters['auth/role']
    },
    id: function () {
      return this.$route.params.id ? this.$route.params.id : this.$store.getters['auth/user'].idCliente
    },
    hasAnyWebHooksModule: function () {
      return this.$store.getters['auth/hasAnyWebHooksModule']
    },
  },
  methods: {
    getParamsAux: function (data) {
      return { idCliente: this.id, idSubscriber: this.$route.params.idWebHook }
    },
    getParamsDetalleAux: function (data) {
      return this.getParamsAux(data)
    },
    getDetalleAux: async function (params) {
      return await getWebhooksDetails(params)
    },
    getExcelAux: async function (payload, params) {
      return await getHistoricalByWebHookExcel(payload, params)
    },
    getPagAux: async function (payload, params) {
      return await getHistoricalByWebHook(payload, params)
    },
    nameRouteCallback: function (data, elthis, breadcrumb) {
      return { path: '', name: data.Nombre }
    },
    nameDataCallback: function (entity, elthis, breadcrumb) {
      return { id: 0, Nombre: entity.Name }
    },
  }
}
</script>

<style lang="scss" scoped></style>
